import { WorkerAction, WorkerActionError, WorkerFnParams } from '../wasm-git.worker.model';
import type { GitAction } from './actions.enum';

export type BranchCommand = '-m' | '-d' | '-u';

export interface GitBranchAction extends WorkerAction {
  type: GitAction.Branch;
  params: { command: BranchCommand; options?: string[] };
}

export class GitBranchActionError extends WorkerActionError {}

export async function GitBranchActionFn(params: WorkerFnParams<GitBranchAction>): Promise<string> {
  try {
    const {
      lg,
      params: { command, options },
    } = params;

    return lg.callAndCaptureOutput(['branch', command, ...(options || [])]);
  } catch (err) {
    throw new GitBranchActionError(err);
  }
}
